import { Swiper } from 'swiper';
import 'swiper/swiper-bundle.css';
import { sendEvent } from '../../helpers/analytics';

const ACTIVE_CLASS = '-active';

export const initPlanCanvas = (node) => {
  const bullets = [...node.querySelectorAll('[data-bullet]')];
  const nextButton = node.querySelector('[data-next]');
  const prevButton = node.querySelector('[data-prev]');

  if (!bullets.length) return;

  const swiper = new Swiper('#plan-canvas', {
    loop: true,
    on: {
      slideChange: (sw) => {
        if (sw.swipeDirection) {
          sendEvent(window.eventCategory, 'plans_modal', `swipe_${sw.swipeDirection}`);
        }
        bullets.forEach((bullet, index) => {
          if (index === sw.realIndex) {
            bullet.classList.add(ACTIVE_CLASS);
          } else {
            bullet.classList.remove(ACTIVE_CLASS);
          }
        });
      },
    },
  });

  bullets.forEach((bullet, index) => {
    bullet.addEventListener('click', () => {
      swiper.slideToLoop(index);
      bullets.forEach((b) => b.classList.remove(ACTIVE_CLASS));
      bullet.classList.add(ACTIVE_CLASS);
    });
  });

  if (nextButton && prevButton) {
    nextButton.addEventListener('click', () => swiper.slideNext());
    prevButton.addEventListener('click', () => swiper.slidePrev());
  }
};
